module.exports = __webpack_public_path__ + "static/media/Nameless.08097b23.png";